import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import BreadCrumb from "./BreadCrumb";

class Header extends React.Component<any, any> {
  render() {
    const {breadCrumbList, title, children} = this.props;
    return <Wrapper>
      <HeaderBox>
        <BreadCrumb breadCrumbList={breadCrumbList}/>
        <HeaderDetail>
          <Title>{title}</Title>
          {children}
        </HeaderDetail>
      </HeaderBox>
    </Wrapper>
  }
}

const Wrapper = styled.div`
  height: 95px;
  padding: ${(p) => p.theme.spacing(2, 0)};
  background: ${p => p.theme.white};
  box-shadow: inset 0 -1px 0 0 #E7E7F0;
`

const HeaderBox = styled.div`
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin: auto;
  padding: ${(p) => p.theme.spacing(0, 6)};
`

const HeaderDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 16px;
`

const Title = styled.div`
  color: ${p => p.theme.formField.color};
	font-size: ${p => p.theme['xxl-font-size']};
  font-weight: ${p => p.theme['font-weight']};
	line-height: 28px;
`

export default withI18n()(Header);
